module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/facebook-alt-1ced0d6ed56a7ea0be00b03c5dd87994.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/facebook-alt.svg
// module id = R34n
// module chunks = 24